var _rect, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#D2D5D6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6402_1069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6402_1069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 20,
    height: 8,
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H21V7.5H1V1Z",
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5H21V21H1V14.5Z",
    fill: "#F8F8F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.a7dabed199481c92ce3157b4f7bc62fd.svg";
export { ForwardRef as ReactComponent };